export default function clear (context, args, flags) {
  context.term = []
  context.input = ''
  context.inputIndex = -1
  return ''
}



// WEBPACK FOOTER //
// ./src/natos/commands/clear.js